import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import AreaPlotChart from './AreaPlotChart';

const schema: JSONSchema7 = {
    title: 'Area Plot Chart',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        chartTitles: headingsSchema,
        options: {
            type: 'array',
            title: 'Area Plot Chart Options',
            items: {
                type: 'object',
                properties: {
                    path: { type: 'string', description: 'Options Object Path' },
                    value: { type: 'string', description: 'High Chart Options as JSON string' },
                },
            },
        },
        legend: {
            type: 'array',
            title: 'Chart legend',
            items: {
                type: 'string',
            },
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['chartTitles', 'options', 'legend'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    chartTitles: {
        items: {
            headerText: {
                'ui:widget': 'ResourcePicker',
            },
        },
    },
    styles: {
        'ui:widget': 'CSSEditor',
    },
};

const AreaPlotChartWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: AreaPlotChart,
    id: 'AreaPlotChart',
    group: 'charts',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default AreaPlotChartWidget;
